import { render, staticRenderFns } from "./pile-detaill.vue?vue&type=template&id=6bb4bee2&scoped=true"
import script from "./pile-detaill.vue?vue&type=script&lang=js"
export * from "./pile-detaill.vue?vue&type=script&lang=js"
import style0 from "./pile-detaill.vue?vue&type=style&index=0&id=6bb4bee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4bee2",
  null
  
)

export default component.exports